import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';
import { pushPayload } from 'seshy/utils/push-payload';
import { hash } from 'rsvp';
import { action } from '@ember/object';

export default class AuthenticatedPlaylistsShowRoute extends BaseRoute {
  @service store;
  @service platform;

  async model(params) {
    let projects = this.store.query('project', {
      filter: { archived: false },
      sort: '-latestVersionUpdatedAt',
      include: 'current-bounce',
    });
    let teams = this.store.query('team', {
      filter: {},
      include: '',
    });
    let playlist = this.store.findRecord('playlist', params.playlist_id, {
      include:
        'owning-team,playlist-entries,playlist-entries.project,playlist-entries.project.current-bounce',
    });

    let model = { playlist, teams, projects };
    console.log('model ==============', model);
    return hash(model);
  }

  @action
  routeRefresh(playlist) {
    console.log('routeRefresh', this.model, playlist);
    playlist.playlistEntries = [];
    this.refresh();
  }
}
